module.exports = __webpack_public_path__ + "static/img/dark.2d1333d6.jpg";